import { p as popperGenerator } from './createPopper-wMe68V__.js';
import { e as eventListeners } from './modifiers/eventListeners-DDxno5DN.js';
import { p as popperOffsets } from './modifiers/popperOffsets-fdoSGhNf.js';
import { c as computeStyles } from './modifiers/computeStyles-BDogV_Kz.js';
import { a as applyStyles } from './modifiers/applyStyles-DJHyPKs0.js';
import { o as offset } from './modifiers/offset-1Mq-DoVi.js';
import { f as flip } from './modifiers/flip-asLBwE2t.js';
import { p as preventOverflow } from './modifiers/preventOverflow-B9kVI9cU.js';
import { a as arrow } from './modifiers/arrow-BQqH6K6n.js';
import { h as hide } from './modifiers/hide-XKG3btjX.js';

var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles, offset, flip, preventOverflow, arrow, hide];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

export { createPopper as c };
//# sourceMappingURL=popper-CAMfwapu.js.map
